import { motion } from "framer-motion";
import { Download, KeyRound, Trophy } from "lucide-react";

const steps = [
  {
    n: "01",
    icon: Download,
    title: "Download",
    desc: "Grab the free app for Windows. No payment required to install — it scans your PC before it changes anything.",
  },
  {
    n: "02",
    icon: KeyRound,
    title: "Unlock",
    desc: "Verify your email, then buy or redeem a plan right inside the app. Access unlocks instantly, no waiting on Discord.",
  },
  {
    n: "03",
    icon: Trophy,
    title: "Dominate",
    desc: "Apply the tweaks that fit your PC. Higher FPS, tighter aim, no more frame drops in the moments that matter.",
  },
];

export const HowItWorks = () => (
  <section id="how" className="relative py-24 sm:py-32 border-y border-white/5 bg-[#070707]" data-testid="how-section">
    <div className="absolute inset-0 bg-grid opacity-20 pointer-events-none" />
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-10% 0px" }}
        transition={{ duration: 0.6 }}
        className="max-w-2xl mb-14"
      >
        <p className="text-orange-500 font-bold tracking-[0.3em] text-xs uppercase mb-4 slash">
          Process
        </p>
        <h2
          className="text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tighter leading-[0.95]"
          style={{ fontFamily: "'Orbitron', sans-serif" }}
        >
          Download. Unlock. <br />
          <span className="text-orange-500">Dominate.</span>
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-10 relative">
        {steps.map((s, i) => {
          const Icon = s.icon;
          return (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 26 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-10% 0px" }}
              transition={{ duration: 0.6, delay: i * 0.12 }}
              className="glass glass-hover !rounded-2xl p-8 sm:p-10 group relative"
              data-testid={`how-step-${i}`}
            >
              <div
                className="absolute top-4 right-6 text-7xl font-black outline-text leading-none"
                style={{ fontFamily: "'Orbitron', sans-serif" }}
              >
                {s.n}
              </div>

              <motion.div
                whileHover={{ rotate: -8, scale: 1.05 }}
                className="w-14 h-14 glass !rounded-xl flex items-center justify-center"
              >
                <Icon className="w-6 h-6 text-orange-500" />
              </motion.div>

              <h3
                className="mt-6 text-2xl font-black uppercase tracking-tight"
                style={{ fontFamily: "'Orbitron', sans-serif" }}
              >
                {s.title}
              </h3>
              <p className="mt-3 text-zinc-400 text-sm leading-relaxed">{s.desc}</p>

              <div className="mt-6 h-px w-12 bg-orange-500 group-hover:w-24 transition-all duration-300" />
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);

